import { BotChatCard } from '@/shared/components/bot-chat-card/bot-chat-card';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TextPayload } from '../../interfaces';
import { BotChatCardType } from '@/shared/enums';

@Component({
  selector: 'bevvi-text-payload',
  imports: [BotChatCard],
  templateUrl: './text-payload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextPayloadComponent {
  public readonly payload = input.required<TextPayload>();
  protected readonly type = BotChatCardType;
}
